import React, { useCallback, useMemo } from "react";
import { config } from "../helpers/configs";
import { useAllieAuth } from "./useAllieAuth";

const DOMAIN = '.alliesystems.com';

export const useFeatureFlag = () => {
  const { loggedUser } = useAllieAuth();
  const isTest = useMemo(() => config.TEST_ENV, [config]);
  const isProd = useMemo(() => !config.TEST_ENV, [config]);
  const subDomain = useMemo(() => window.location.hostname.replace(DOMAIN, ''), []);
  const isCompany = useCallback((company: string | string[]) => {
    const target = company instanceof Array ? company : [company];
    return target.includes(subDomain);
  }, [config]);

  const renderOnTest = useCallback((component: React.ReactNode) => (
    config.TEST_ENV && component
  ), [config]);

  const renderOnCompany = useCallback((
    component: React.ReactNode,
    whitelist: string[] = [],
    blacklist: string[] = [],
  ) => {
    if (!blacklist.length && !whitelist.length) return component; 
    if (!blacklist.length && whitelist.length && whitelist.includes(subDomain)) return component; 
    if (blacklist.length && !whitelist.length && !blacklist.includes(subDomain)) return component; 
    if (blacklist.length && whitelist.length && whitelist.includes(subDomain)
        && !blacklist.includes(subDomain)) return component;

    return undefined;
  }, [config]);

  const isAllieAssistant = useMemo(() => loggedUser?.name === 'allie_assistant', [loggedUser]);

  return { isTest, isProd, isCompany, renderOnTest, renderOnCompany, isAllieAssistant };
}
